import { useEffect, useRef } from 'react';
import { TrackablePageName } from '../constants';
import useEventTracker, { Parameter } from './useEventTracker';

export const usePageEventTracker = (pageName: TrackablePageName, parameters?: Parameter[]) => {
  const trackEvent = useEventTracker();
  const isEventSentRef = useRef(false);

  useEffect(() => {
    if (isEventSentRef.current) return;

    isEventSentRef.current = true;

    const resolvedParameters: Parameter[] = [{ name: 'page_name', stringValue: pageName }, ...(parameters ?? [])];

    trackEvent('page_view', 'navigation', resolvedParameters);
  }, [pageName, parameters, trackEvent]);
};
